export const OK = 'OK';
export const PERSISTENT_FAIL = 'PERSISTENT_FAIL';
export const OCCASIONAL_FAIL = 'OCCASIONAL_FAIL';
